import { Button, Grid, TableCell, TableRow } from "@material-ui/core";
import React, { FC, useState } from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale, SwissTimeZone } from "../../data/constants";
import {
  CandidateCourseStatus,
  CandidateCourseStatusTranslationKey,
  CandidateCourseViewModel,
  isCertificateAvailable
} from "../../model/courses/CandidateCourseViewModel";
import { GetTranslatedValueIntl } from "../../model/Shared/TranslatedValue";
import TranslatedMessage from "../translations/TranslatedMessage";

interface CandidateCourseTableRowProps {
  candidateCourse: CandidateCourseViewModel;
  handleDownloadCertificate: (candidateCourse: CandidateCourseViewModel) => Promise<void>;
  handleDownloadPerformanceRecord: (candidateCourse: CandidateCourseViewModel) => Promise<void>;
}

const CandidateCourseTableRow: FC<CandidateCourseTableRowProps> = ({
  candidateCourse,
  handleDownloadCertificate,
  handleDownloadPerformanceRecord,
}) => {
  const intl = useIntl();
  const [isLoadingCertificate, setIsLoadingCertificate] = useState(false);
  const [isLoadingPerformanceRecord, setIsLoadingPerformanceRecord] = useState(false);

  const onDownloadCertificate = async () => {
    setIsLoadingCertificate(true);
    await handleDownloadCertificate(candidateCourse);
    setIsLoadingCertificate(false);
  };

  const onDownloadPerformanceRecord = async () => {
    setIsLoadingPerformanceRecord(true);
    await handleDownloadPerformanceRecord(candidateCourse);
    setIsLoadingPerformanceRecord(false);
  };

  return (
    <TableRow>
      <TableCell>{GetTranslatedValueIntl(intl, candidateCourse.courseName)}</TableCell>
      <TableCell>
        {candidateCourse.status === CandidateCourseStatus.Passed &&
          candidateCourse.closingDateUtc &&
          new Date(candidateCourse.closingDateUtc).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone })}
      </TableCell>
      <TableCell>{<TranslatedMessage id={CandidateCourseStatusTranslationKey[candidateCourse.status]} />}</TableCell>
      <TableCell>
        <Grid container spacing={1} direction="row" justify="flex-start">
          {isCertificateAvailable(candidateCourse) && (
            <Grid item>
              <Button
                variant="contained"
                size="small"
                style={{ textTransform: "none" }}
                onClick={onDownloadCertificate}
                disabled={isLoadingCertificate}
              >
                <TranslatedMessage id="home.myCourses.downloadCertificate" />
              </Button>
            </Grid>
          )}
          <Grid item>
            <Button
              variant="contained"
              size="small"
              style={{ textTransform: "none" }}
              onClick={onDownloadPerformanceRecord}
              disabled={isLoadingPerformanceRecord}
            >
              <TranslatedMessage id="home.myCourses.downloadPerformanceRecord" />
            </Button>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default CandidateCourseTableRow;
